<template>
  <div v-if="isVisible" class="cookie-banner slide-up">
    <div class="cookie-content">
      <div class="cookie-text">
        <p>
          {{ t('cookie.description') || 'We use cookies to improve your experience and analyze site traffic. By clicking "Accept", you agree to our use of cookies.' }}
        </p>
      </div>
      <div class="cookie-actions">
        <button @click="decline" class="btn-decline">
          {{ t('cookie.decline') || 'Decline' }}
        </button>
        <button @click="accept" class="btn-accept">
          {{ t('cookie.accept') || 'Accept' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { shouldShowBanner, setConsent } from '@/utils/analytics'
import { t } from '@/utils/i18n'

const isVisible = ref(false)

onMounted(() => {
  // Check if we should show the banner (small delay for animation)
  if (shouldShowBanner()) {
    setTimeout(() => {
      isVisible.value = true
    }, 1000)
  }
})

const accept = () => {
  setConsent('accepted')
  isVisible.value = false
}

const decline = () => {
  setConsent('declined')
  isVisible.value = false
}
</script>

<style scoped>
.cookie-banner {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: var(--color-primary-orange);
  color: white;
  padding: var(--space-md) var(--space-base);
  box-shadow: 0 -4px 10px rgba(0, 0, 0, 0.1);
  z-index: 9999;
}

.cookie-content {
  max-width: 1280px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: var(--space-md);
  align-items: center;
  justify-content: space-between;
}

@media (min-width: 640px) {
  .cookie-content {
    flex-direction: row;
    text-align: left;
  }
}

.cookie-text p {
  margin: 0;
  font-size: var(--font-size-small);
  line-height: 1.5;
}

.cookie-actions {
  display: flex;
  gap: var(--space-md);
  flex-shrink: 0;
}

.btn-accept, .btn-decline {
  padding: 8px 16px;
  border-radius: var(--radius-md);
  font-weight: 600;
  font-size: var(--font-size-small);
  cursor: pointer;
  transition: all 0.2s;
  border: 2px solid white;
}

.btn-accept {
  background-color: white;
  color: var(--color-primary-orange);
}

.btn-accept:hover {
  background-color: #f0f0f0;
  transform: translateY(-1px);
}

.btn-decline {
  background-color: transparent;
  color: white;
}

.btn-decline:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

/* Animation */
.slide-up {
  animation: slideUp 0.5s ease-out forwards;
}

@keyframes slideUp {
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
}
</style>
